import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import * as _Highcharts from 'highcharts';
import {ExportingOptions} from 'highcharts';

@Injectable({
  providedIn: 'root'
})
export class ChartExportSettingsGeneratorService {

  constructor(private translationService: TranslateService) {
  }

  public generateExportingSettings(isLineChart: boolean, chartSettings): ExportingOptions {
    if (isLineChart) {
      return {
        buttons: {
          contextButton: {
            enabled: false
          }
        }
      };
    }

    return {
      buttons: {
        contextButton: {
          enabled: false
        }
      },

      csv: {
        columnHeaderFormatter: (item, key) => {
          let columnName = this.translationService.instant('Date/Time [UTC]');

          if (!item || item instanceof _Highcharts.Axis) {
            return columnName;
          }
          if (key === 'y') {
            columnName = item.name;
          } else if (key === 'low') {
            columnName = item.name.replace('range', 'min');
          } else if (key === 'high') {
            columnName = item.name.replace('range', 'MAX');
          } else {
            columnName = 'timestamp';

          }
          return {
            topLevelColumnTitle: this.exportDocumentTitle(chartSettings),
            columnTitle: columnName
          };
        },
        dateFormat: this.getDateTimeExportPattern(chartSettings)
      }

    };
  }

  private exportDocumentTitle(chartSettings) {
    return this.exportGetSelectedInterval(chartSettings) + ' / ' + this.exportGetValuesAggregationInterval(chartSettings);
  }

  private exportGetSelectedInterval(chartSettings) {
    return this.translationService.instant(chartSettings.intervalDetails.selectedInterval);
  }

  private exportGetValuesAggregationInterval(chartSettings) {
    return chartSettings.intervalDetails.settings.label;
  }

  private getDateTimeExportPattern(chartSettings) {
    return chartSettings.intervalDetails.settings.hc_format;
  }
}
